var map = {
	"./cloudIcon-active0.svg": 93517,
	"./cloudIcon-active1.svg": 41708,
	"./cloudIcon-active2.svg": 20735,
	"./cloudIcon.svg": 33588,
	"./collectIcon-active0.svg": 41192,
	"./collectIcon-active1.svg": 49113,
	"./collectIcon-active2.svg": 4714,
	"./collectIcon.svg": 25733,
	"./commuityIcon-active0.svg": 67837,
	"./commuityIcon-active1.svg": 39292,
	"./commuityIcon-active2.svg": 18319,
	"./commuityIcon.svg": 56516,
	"./courseIcon-active0.svg": 76302,
	"./courseIcon.svg": 9416,
	"./dropboxIcon-active0.svg": 36896,
	"./dropboxIcon-active1.svg": 99697,
	"./dropboxIcon-active2.svg": 45154,
	"./dropboxIcon.svg": 1245,
	"./groupIcon-active0.svg": 13895,
	"./groupIcon-active1.svg": 50070,
	"./groupIcon-active2.svg": 38293,
	"./groupIcon.svg": 78214,
	"./importIcon-active0.svg": 53737,
	"./importIcon-active1.svg": 28376,
	"./importIcon-active2.svg": 86443,
	"./importIcon.svg": 39184,
	"./new/Basic-active.svg": 99444,
	"./new/Basic-active0.svg": 67820,
	"./new/Basic-active1.svg": 15181,
	"./new/Basic-active2.svg": 32206,
	"./new/Basic.svg": 44585,
	"./new/Business-active.svg": 33062,
	"./new/Business-active0.svg": 15210,
	"./new/Business-active1.svg": 55432,
	"./new/Business-active2.svg": 51688,
	"./new/Business.svg": 41927,
	"./new/Design-active.svg": 51002,
	"./new/Design-active0.svg": 87654,
	"./new/Design-active1.svg": 76631,
	"./new/Design-active2.svg": 22180,
	"./new/Design.svg": 35363,
	"./new/Education-active.svg": 71188,
	"./new/Education-active0.svg": 23212,
	"./new/Education-active1.svg": 22157,
	"./new/Education-active2.svg": 73806,
	"./new/Education.svg": 42377,
	"./new/Engineering-active.svg": 94189,
	"./new/Engineering-active0.svg": 82935,
	"./new/Engineering-active1.svg": 77606,
	"./new/Engineering-active2.svg": 48114,
	"./new/Engineering.svg": 20054,
	"./new/Floor-active0.svg": 93080,
	"./new/Floor.svg": 42453,
	"./new/Internet-active.svg": 28193,
	"./new/Internet-active0.svg": 49699,
	"./new/Internet-active1.svg": 35058,
	"./new/Internet-active2.svg": 50574,
	"./new/Internet.svg": 35426,
	"./new/MyTemplate-active.svg": 34872,
	"./new/MyTemplate-active0.svg": 49400,
	"./new/MyTemplate-active1.svg": 8553,
	"./new/MyTemplate-active2.svg": 82970,
	"./new/MyTemplate.svg": 65429,
	"./new/Project-active0.svg": 50241,
	"./new/Project.svg": 34984,
	"./new/Recent-active.svg": 17371,
	"./new/Recent-active0.svg": 78529,
	"./new/Recent-active1.svg": 66288,
	"./new/Recent-active2.svg": 27779,
	"./new/Recent.svg": 48955,
	"./new/Recommend-active.svg": 55768,
	"./new/Recommend-active0.svg": 21464,
	"./new/Recommend-active1.svg": 9353,
	"./new/Recommend-active2.svg": 41242,
	"./new/Recommend.svg": 45493,
	"./new/Software-active.svg": 43093,
	"./new/Software-active0.svg": 74991,
	"./new/Software-active1.svg": 54942,
	"./new/Software-active2.svg": 1213,
	"./new/Software.svg": 88654,
	"./new/add.svg": 77130,
	"./new/points.svg": 68912,
	"./newPageIcon-active0.svg": 41809,
	"./newPageIcon-active1.svg": 84896,
	"./newPageIcon-active2.svg": 75635,
	"./newPageIcon.svg": 48664,
	"./pc/cloudIcon-active.svg": 34633,
	"./pc/cloudIcon0.svg": 60166,
	"./pc/cloudIcon1.svg": 47703,
	"./pc/cloudIcon2.svg": 4580,
	"./pc/collectIcon-active.svg": 88758,
	"./pc/collectIcon0.svg": 43525,
	"./pc/collectIcon1.svg": 92356,
	"./pc/collectIcon2.svg": 35479,
	"./pc/historyIcon-active.svg": 62792,
	"./pc/historyIcon0.svg": 57983,
	"./pc/historyIcon1.svg": 29550,
	"./pc/historyIcon2.svg": 77901,
	"./pc/publishFileIcon-active.svg": 13473,
	"./pc/publishFileIcon0.svg": 70334,
	"./pc/publishFileIcon1.svg": 90383,
	"./pc/publishFileIcon2.svg": 4412,
	"./pc/sharetomeIcon-active.svg": 95804,
	"./pc/sharetomeIcon0.svg": 94211,
	"./pc/sharetomeIcon1.svg": 79570,
	"./pc/sharetomeIcon2.svg": 72705,
	"./pc/starFileIcon-active.svg": 88190,
	"./pc/starFileIcon0.svg": 66861,
	"./pc/starFileIcon1.svg": 19500,
	"./pc/starFileIcon2.svg": 98527,
	"./pc/trashIcon-active.svg": 90162,
	"./pc/trashIcon0.svg": 90801,
	"./pc/trashIcon1.svg": 92768,
	"./pc/trashIcon2.svg": 37427,
	"./shortcut/block-diagram.svg": 63252,
	"./shortcut/chen-erd.svg": 50373,
	"./shortcut/circle-spoke-diagram.svg": 22982,
	"./shortcut/circuit.svg": 61834,
	"./shortcut/concept-map.svg": 65662,
	"./shortcut/floorplan.svg": 7260,
	"./shortcut/flow-chart.svg": 95314,
	"./shortcut/gantt.svg": 67773,
	"./shortcut/genogram.svg": 61069,
	"./shortcut/icon-empty.svg": 5566,
	"./shortcut/icon-master.svg": 15437,
	"./shortcut/icon-max.svg": 151,
	"./shortcut/icon-pixso.svg": 36316,
	"./shortcut/icon-project.svg": 62974,
	"./shortcut/mind-mapping.svg": 32736,
	"./shortcut/network.svg": 3253,
	"./shortcut/org-chart-auto.svg": 66478,
	"./shortcut/process-p&id.svg": 62024,
	"./shortcut/roadmap.svg": 88435,
	"./shortcut/software-arch.svg": 40279,
	"./shortcut/swimlane.svg": 91239,
	"./shortcut/uml.svg": 62237,
	"./trashIcon-active0.svg": 87136,
	"./trashIcon-active1.svg": 1521,
	"./trashIcon-active2.svg": 44418,
	"./trashIcon.svg": 75485
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99574;